import React, { createContext, useContext, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { Button } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { v4 as uuidv4 } from "uuid";

import UserContext from "../../contexts/user";
import { AuthContext } from "../../containers/user-auth";
import {
  gql,
  useApolloClient,
  useMutation,
  useQuery,
  useLazyQuery,
} from "@apollo/client";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import * as Sentry from "@sentry/react";
import { Question } from "../../types/quiz";
import { INSERT_POST_ONE } from "../../gql/forum";
import { string } from "yup";
import axios from "axios";

import AlertModal from "../../components/alert-modal";

const ForgotPassword: React.FC = () => {
  const intl = useIntl();
  const userContext = useContext(UserContext);
  const authContext = useContext(AuthContext);
  const apolloClient = useApolloClient();

  const { currentEvent } = userContext;
  const { login, setPage } = authContext;

  const [showAlertModal, setShowAlertModal] = useState(false);
  const handleAlertModal = () => {
    setShowAlertModal(!showAlertModal);
  };
  const [alertType, setAlertType] = useState("");
  const slug = document.location.pathname.split("/")[1] || "invalid";
  const redirectUrl = window.location.href;
  const [message, setMessage] = useState("");
  return (
    <>
      <Formik
        initialValues={{
          email: "",
        }}
        onSubmit={async (values) => {
           console.log(
            "userContext.currentEvent._id",
            userContext.currentEvent._id
          );

          await axios
            .post(
              `${process.env.REACT_APP_API_ENDPOINT}/api/event-engagement/${userContext.currentEvent._id}/user-forgot-password`,

              {
                email: values.email,
                redirect: redirectUrl,
                // redirect: `${process.env.REACT_APP_API_ENDPOINT}/${slug}`,
                // redirect: "http://localhost:3001/presentation-des-services-aleou/",
                // redirect: `${process.env.REACT_APP_MANAGER_SITE_ROOT}?resettoken=`,
              }
            )
            .then((response) => {
               console.log(
                "response.data.data--------------------------------------------------------------",
                response.data.data
              );
              setAlertType("Success");
              setMessage("email send check you inbox");
              setShowAlertModal(true);
            })
            .catch((error) => {
               console.log(error);
              setAlertType("Error");
              setMessage("invalid user email Id");
              setShowAlertModal(true);
            });
        }}
      >
        {({ isSubmitting }) => {
          return (
            <Form className="m-t-30">
              <h4>
                <FormattedMessage id="forgot.header" />
              </h4>
              <div className="form-group m-t-10">
                <Field
                  required
                  placeholder={intl.formatMessage({ id: "input.email" })}
                  className="form-control"
                  type="email"
                  name="email"
                />
                <ErrorMessage
                  className="invalid-feedback"
                  name="email"
                  component="div"
                />
              </div>
              <div className="login-button-container m-t-20">
                <Button
                  onClick={function () {
                    userContext.setShowLogin(false);
                  }}
                  color="link"
                  type="button"
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({
                        id: "auth.continue.without.login",
                      }),
                    }}
                  ></span>
                </Button>
                <div>
                  <Button color="primary" type="submit" disabled={isSubmitting}>
                    <FormattedMessage id="common.enter.button" />
                  </Button>
                </div>
              </div>
              <div className="common-styles m-t-20">
                <Button
                  onClick={() => setPage("login")}
                  color="link"
                  type="button"
                >
                  {intl.formatMessage({ id: "auth.back.to.signin" })}
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
      <AlertModal
        show={showAlertModal}
        handleClose={handleAlertModal}
        type={alertType}
        message={message}
      />
    </>
  );
};

export default ForgotPassword;
